import React from 'react';

import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Card } from '@lightspeed/flame/Card';
import { Box, Flex } from '@lightspeed/flame/Core';
import { IconClose } from '@lightspeed/flame/Icon/Close';
import { Text, TextLink } from '@lightspeed/flame/Text';

import { createReactRenderer } from 'helpers/react-renderer';
import useLocalizedLink from 'root/apps/hooks/useLocalizedLink';

const UnstyledButton = styled(Button)`
  width: 10px;
  height: 10px;
  background: none;
  background-image: none;
  outline: none;
  border: none;
  box-shadow: none;
  padding: 0;
  min-height: 0;
  text-decoration: none;
`;

const NuOrderBanner: React.FC = () => {
  const [isBannerOpen, setIsBannerOpen] = React.useState(false);

  const NUORDER_HELP_CENTRE_URL = useLocalizedLink(
    'https://retail-support.lightspeedhq.com/hc/{{locale}}/articles/38633631918363-Placing-integrated-purchase-orders-with-Retail-POS-R-Series-and-NuORDER'
  );

  const handleClose = () => {
    setIsBannerOpen(false);
    window.lsCloud.UserPreferences.save('ui_tab', 'inventory', 'nuorder_banner', 'hide');
  };

  React.useEffect(() => {
    window.lsCloud.UserPreferences.get('ui_tab', 'inventory', 'nuorder_banner').then((value) => {
      if (value === 'hide') {
        setIsBannerOpen(false);
      } else {
        setIsBannerOpen(true);
      }
    });
  }, []);

  return (
    <>
      {isBannerOpen ? (
        <Card mb={2} p={2}>
          <Flex justifyContent="space-between">
            <Box>
              <Flex>
                <img
                  alt="NuORDER Purchase Order Banner Hero"
                  src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-118c0e2/images/nuorder/nuorder-link-banner.svg"
                />
                <Flex flexDirection="column">
                  <Text
                    fontWeight={700}
                    fontSize={21}
                    mt={20}
                    data-test="nuorder-purchase-order-banner-title"
                  >
                    Streamline Reorders to NuORDER
                  </Text>
                  <Text mt={2} data-test="nuorder-purchase-order-banner-text">
                    Create a purchase order in Lightspeed and send it directly to your NuORDER
                    suppliers in one click.{' '}
                    <TextLink
                      href={NUORDER_HELP_CENTRE_URL}
                      target="_blank"
                      data-test="nuorder-purchase-order-banner-link"
                    >
                      Learn more
                    </TextLink>
                  </Text>
                  <Button
                    data-test="nuorder-purchase-order-banner-btn"
                    onClick={() => window.PageRouter.goTo('/inventory/vendors/b2b')}
                    variant="secondary"
                    fill
                    width="215px"
                    mt={3}
                  >
                    Link accounts
                  </Button>
                </Flex>
              </Flex>
            </Box>
            <UnstyledButton
              onClick={() => handleClose()}
              data-test="nuorder-purchase-order-banner-close-btn"
            >
              <IconClose baseColor="lightgrey" />
            </UnstyledButton>
          </Flex>
        </Card>
      ) : null}
    </>
  );
};

export default NuOrderBanner;

const RenderedComponent = createReactRenderer({
  component: NuOrderBanner,
  selector: '[data-react-root="NuorderLinkBanner"]',
});

history.onChangeState(
  [
    {
      name: ['purchase.views.master_order', 'purchase.views.purchase'],
      form_name: 'view',
      tab: ['master', 'main', 'import'],
      id: undefined,
    },
    { form_name: 'ui_tab', tab: 'inventory' },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
